<script>
    import { bgColor } from "./stores/background_color.js";
    import { createEventDispatcher, onDestroy, onMount } from "svelte";
    import Logo from "./Logo.svelte";

    const dispatch = createEventDispatcher();

    let emojis = ["🥂", "🕺", "🍷", "💃", "🧑‍🎤", "🎉", "🎉"];

    $: currentEmoji = emojis[Math.floor(Math.random() * emojis.length)];

    let us_bgColor;

    function close() {
        dispatch("close");
    }

    onMount(() => {
        us_bgColor = bgColor.subscribe(() => {
            currentEmoji = emojis[Math.floor(Math.random() * emojis.length)];
        });
    });

    onDestroy(() => {
        us_bgColor();
    });
</script>

<div
    on:keydown={{}}
    on:click={close}
    class="bg fixed size-full flex items-center content-center justify-center"
>
    <div
        on:keydown={{}}
        on:click|stopPropagation
        class="popup brightness-[1.25] saturate-[2.4] flex items-center content-center flex-col backdrop-blur-[5px] shadow-[0px_90px_70px_-100px_black] text-white text-base p-7 rounded-2xl bg-[radial-gradient(#4343436b, #0000001c)] max-w-lg w-full text-center m-6"
    >
        <div class="logo mx-2.5 my-5;">
            <Logo size={100}></Logo>
        </div>
        <h class="text-4xl font-semibold m-4">Welcome to House Party!</h>
        <h2 class="text-2xl">Your ultime app for house parties</h2>
        <p class="text-lg mt-8">
            Say goodbye to friends messing with your laptop. Create and share
            playlists for your parties, and let friends add and rate songs from
            their phones. Keep the vibes flowing with House Party!
        </p>
        <p class="emoji text-5xl mt-6">{currentEmoji}</p>
        <div class="button" on:click={close} on:keydown={{}}>
            Cool story, bro
        </div>
    </div>
</div>

<style>
    .emoji {
        filter: brightness(0.9) contrast(0.7) saturate(0.6);
    }
    .bg {
        background: #00000070;
    }
    .popup {
        background: radial-gradient(#ffffff26, #0000008c),
            radial-gradient(circle at bottom, #c3f8ff6b, #ffffff57);
        font-family: "Paytone One";
        color: #fff;
        /* border: 3px solid #ffffff57; */
    }

    .logo {
        height: 150px;
        width: 150px;
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        /* background: #242424c4; */
        background: radial-gradient(#000000c7, black);
        border-radius: 100%;
        padding: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
        filter: saturate(0.6) brightness(0.85);
    }

    .button {
        width: 214px;
        height: 58px;
        background: #ffffff05;
        margin-top: 30px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        color: #fff;
        font-size: 18px;
        font-family: "Dosis";
        font-family: "Catamaran";
        font-family: "Luckiest Guy";
        font-family: "Paytone One";
        text-align: left;
        padding: 5px;
        border: 4px solid white;
        border-radius: 120px;
        cursor: pointer;
    }

    .button:hover {
        background: #ffffff30;
    }

    @media (max-width: 496px), (max-height: 600px) {
        .popup {
            margin: 0;
            padding: 22px;
            width: 100vw;
            height: 100vh;
            border: none;
            border-radius: 0;
            justify-content: center;
            max-width: unset;
        }
    }

    @media (max-height: 550px) {
        .emoji {
            display: none;
        }
    }
</style>
